import React, { useState, useEffect, useContext, useRef } from 'react';
import './ContactUsContents.css';
import TextInput from '../TextInput/TextInput';
import PhoneInput from '../PhoneInput/PhoneInput';
import EmailInput from '../EmailInput/EmailInput';
import CheckboxListInput from '../CheckboxListInput/CheckboxListInput';
import ActionButtons from '../ActionButtons/ActionButtons';
import baseApi from '../../common/api/base';
import logComponent from '../../common/logComponent';
import SocialIcon from '../SocialIcons/SocialIcon';
import Logo from '../Logo/Logo';
import StatusFooter from '../StatusFooter/StatusFooter';

export default function ContactUsContents() {
  const [validating, setValidating] = useState(false);
  const [isValid, setIsValid] = useState(null);
  const [showErrors, setShowErrors] = useState(false);
  const [status, setStatus] = useState('initial');
  const [outcomes, setOutcomes] = useState([{ 'text': 'Communication', 'criteria': [{ 'field': 'outcomes', 'acceptedValues': ['Communication'] }] }, { 'text': 'LifeSafety', 'criteria': [{ 'field': 'outcomes', 'acceptedValues': ['LifeSafety'] }] }, { 'text': 'Security', 'criteria': [{ 'field': 'outcomes', 'acceptedValues': ['Security'] }] }, { 'text': 'Mass Notification', 'criteria': [{ 'field': 'outcomes', 'acceptedValues': ['Mass Notification'] }] }, { 'text': 'Environmental Monitoring', 'criteria': [{ 'field': 'outcomes', 'acceptedValues': ['Environmental Monitoring'] }] }, { 'text': 'Data/Analytics', 'criteria': [{ 'field': 'outcomes', 'acceptedValues': ['Data/Analytics'] }] }, { 'text': 'Other', 'criteria': [{ 'field': 'outcomes', 'acceptedValues': ['Other'] }] }])
  const [contactUs, setContactUs] = useState({
    Name: null,
    EmailAddress: null,
    PhoneNumber: null,
    Company: null,
    State: null,
    Role: null,
    Outcomes: []

  });
  const contactUsRef = useRef({
    Name: null,
    EmailAddress: null,
    PhoneNumber: null,
    Company: null,
    State: null,
    Role: null,
    Outcomes: []
  });

  const setContactUsRef = (el) => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents setupdatedContactRef'); }
    contactUsRef.current = el;
  }

  const formIsInvalid = isValid === false;

  const formRef = useRef(null);
  const firstTabRef = useRef(null);
  const actionButtons = useRef(null);

  if (logComponent('ContactUsContents')) { console.debug('ContactUsContents rendered'); }


  useEffect(() => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents useEffect [status]'); }
    // handle submission failure
    if (status === 'failure') {
      formRef.current.scrollTop = 0;
    }
  }, [status])

  const showValidationErrors = () => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents showValidationErrors'); }
    setShowErrors(true);
  }

  const hideValidationErrors = () => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents hideValidationErrors'); }
    setShowErrors(false);
  }

  const validateField = (field) => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents validateField'); }
    let newUpdatedContact = { ...contactUsRef.current };
    newUpdatedContact[field.name] = field;
    setContactUsRef(newUpdatedContact);
    setContactUs(newUpdatedContact);
  }


  const submit = () => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents submit'); }


    //waiting for a second so it will get the last validate field 
    setTimeout(() => {
      let requiredFieldList = getRequiredFieldList();

      if (!requiredFieldList) {
        handleInvalidSubmission();
        return;
      }

      let isValid = requiredFieldList.reduce((prev, curr) => prev && contactUs[curr] && contactUs[curr].isValid, true);

      if (!isValid) {
        handleInvalidSubmission();
      } else {

        handleValidSubmission();

      }

    }, 1000);

  }

  const handleValidSubmission = () => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents handleValidSubmission'); }
    hideValidationErrors();
    submitContactUs();
    setIsValid(true);
  }

  const handleInvalidSubmission = () => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents handleInvalidSubmission'); }

    showValidationErrors();
    formRef.current.scrollTop = 0;
    focusFirstItem();
    setIsValid(false);
    reset(); // necessary?
  }

  const getRequiredFieldList = () => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents getRequiredFieldList'); }

    return ['Name', 'EmailAddress', 'PhoneNumber', 'Company', 'State', 'Role'];
  }

  const submitContactUs = () => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents updateContact'); }


    let contactUsToSubmit = { ...contactUsRef.current };


    setStatus('pending');

    let contactUsEntries = Object.entries(contactUs);

    contactUsEntries.forEach(entry => {
      contactUsToSubmit[entry[0]] = entry[1] ? entry[1].value : null;
    });
    // Add/Modify fields as necessary
    if (contactUsRef.current.Outcomes != null && Array.isArray(contactUsRef.current.Outcomes.values)) { 
      let newOutcomesArrays = [...contactUsRef.current.Outcomes.values];
      let newOutcomes = newOutcomesArrays.flat()
      contactUsToSubmit.Outcomes = newOutcomes;
    }


    baseApi.ContactUs.Submit(contactUsToSubmit)
      .then(
        result => {
          setStatus('success');

        },
        error => {
          setStatus('failure');
        }
      )
  }

  const reset = () => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents reset'); }
    setStatus('initial');
  }

  const focusFirstItem = () => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents focusFirstItem'); }
    if (firstTabRef && firstTabRef.current) firstTabRef.current.focus();
  }

  const handleShiftTab = (e) => {
    if (logComponent('ContactUsContents')) { console.debug('ContactUsContents handleShiftTab'); }
    const { key, shiftKey } = e;

    if (key !== 'Tab' || !shiftKey) return;

    e.preventDefault();
    if (actionButtons && actionButtons.current) actionButtons.current.focus();
  }




  return (
    <div className="Contact-Us-Contents">
      <div className="Contact-Us-Contents__content">
        <div className="Contact-Us-Contents__hero">
          <p className="Contact-Us-Contents__hero-message">Welcome to MIMI</p>
          <p className="Contact-Us-Contents__hero-slogan">Merging Information <span className="Landing__italic">into</span> Meaningful Insights</p>
          <div className="Contact-Us-Contents__logo-frame">
            <Logo />
          </div>
        </div>
        <main className="Contact-Us-Contents__main">
          <div className="Contact-Us-Contents__info">
            <div className="Contact-Us-Contents__info__heading">Let's Connect</div>
            <div className="Contact-Us-Contents__info__section">
              <div className="Contact-Us-Contents__info__section__heading">STATUS SOLUTIONS HEADQUARTERS</div>
              <div className="Contact-Us-Contents__info__section__details">999 County Line Road W, Westerville, OH 43082</div>
            </div>
            <div className="Contact-Us-Contents__info__section">
              <div className="Contact-Us-Contents__info__section__heading">HEAD OFFICE</div>
              <div className="Contact-Us-Contents__info__section__details">(866) 846-7272</div>
              <div className="Contact-Us-Contents__info__section__details">info@statussolutions.com</div>
            </div>
            <div className="Contact-Us-Contents__info__section">
              <div className="Contact-Us-Contents__info__section__heading">SUPPORT</div>
              <div className="Contact-Us-Contents__info__section__details">(866) 846-7272, option 1</div>
              <div className="Contact-Us-Contents__info__section__details">support@statussolutions.com</div>
            </div>
            <div className="Contact-Us-Contents__info__social">
              <SocialIcon className="Contact-Us-Contents__info__social__icon" style={{ height: '1.75rem', width: '1.75rem', color: '#cc0000' }} type="F" link="https://www.facebook.com/StatSol/" />
              <SocialIcon className="Contact-Us-Contents__info__social__icon" style={{ height: '1.75rem', width: '1.75rem', color: '#cc0000' }} type="T" link="https://twitter.com/statussol/" />
              <SocialIcon className="Contact-Us-Contents__info__social__icon" style={{ height: '1.75rem', width: '1.75rem', color: '#cc0000' }} type="Y" link="https://www.youtube.com/channel/UCkejzacCB2_A7ed8n9Kw9yw" />
              <SocialIcon className="Contact-Us-Contents__info__social__icon" style={{ height: '1.75rem', width: '1.75rem', color: '#cc0000' }} type="L" link="https://www.linkedin.com/company/status-solutions/" />
            </div>                                                    ,
          </div>
          <div className="Contact-Us-Contents__submission" ref={formRef}>
            <p className={'Contact-Us-Contents__submission__page-error' + (showErrors ? ' visible' : '')}>There were some errors. Please double check the information and resubmit.</p>
            <p className={'Contact-Us-Contents__submission__page-error' + (status === 'failure' ? ' visible' : '')}>Sorry, something went wrong.  Contact us request was not sent.  Please try again.</p>
            <p className={'Contact-Us-Contents__submission__page-success' + (status === 'success' ? ' visible' : '')}>Thank you for your interest in Status Solutions.   We have received your request and our team is currently reviewing it.</p>
            <form className="Contact-Us-Contents__submission__form">
              <div className="Contact-Us-Contents__submission__form__row">
                <div className="Contact-Us-Contents__submission__form__row__field">
                  <TextInput
                    label="Name"
                    name="Name"
                    rules={{ required: true }}
                    errorMessages={{ required: 'Please provide your name' }}
                    showError={formIsInvalid}
                    validate={validating}
                    onValidate={validateField}
                    ref={firstTabRef}
                    onKeyDown={handleShiftTab} />
                </div>
                <div className="Contact-Us-Contents__submission__form__row__field">
                  <EmailInput
                    label="Email address"
                    name="EmailAddress"
                    rules={{ required: true }}
                    errorMessages={[
                      {
                        rules: ['required', 'validEmail'],
                        text: 'Please provide a valid email address'
                      }
                    ]}
                    showError={formIsInvalid}
                    validate={validating}
                    onValidate={validateField}
                    requireEmailUniqueness={false} />
                </div>
              </div>
              <div className="Contact-Us-Contents__submission__form__row">
                <div className="Contact-Us-Contents__submission__form__row__field">
                  <PhoneInput
                    label="Phone number"
                    name="PhoneNumber"
                    rules={{ maxLength: 10, required: true }}
                    errorMessage="Please provide a valid phone number"
                    showError={formIsInvalid}
                    validate={validating}
                    onValidate={validateField} />
                </div>
                <div className="Contact-Us-Contents__submission__form__row__field">
                  <TextInput
                    label="Company"
                    name="Company"
                    rules={{ required: true }}
                    errorMessages={{ required: 'Please provide your company' }}
                    showError={formIsInvalid}
                    validate={validating}
                    onValidate={validateField}
                    ref={firstTabRef}
                    onKeyDown={handleShiftTab} />
                </div>
              </div>
              <div className="Contact-Us-Contents__submission__form__row">
                <div className="Contact-Us-Contents__submission__form__row__field">
                  <TextInput
                    label="State"
                    name="State"
                    rules={{ required: true }}
                    errorMessages={{ required: 'Please provide your state' }}
                    showError={formIsInvalid}
                    validate={validating}
                    onValidate={validateField}
                    ref={firstTabRef}
                    onKeyDown={handleShiftTab} />
                </div>
                <div className="Contact-Us-Contents__submission__form__row__field">
                  <TextInput
                    label="Role"
                    name="Role"
                    rules={{ required: true }}
                    errorMessages={{ required: 'Please provide your role' }}
                    showError={formIsInvalid}
                    validate={validating}
                    onValidate={validateField}
                    ref={firstTabRef}
                    onKeyDown={handleShiftTab} />
                </div>
              </div>
              <div className="Contact-Us-Contents__submission__form__row">

              <CheckboxListInput className="Contact-Us-Contents__submission__form__row__field"
                initialValues={['Data/Analytics']}
                label="Please check what type of outcome that you are interested in learning more about. *You may check more than one box.*"
                name="Outcomes"
                showError={formIsInvalid}
                errorMessage="Please select one or more outcomes"
                rules={{ minItems: 1 }}
                onValidate={validateField}
                items={outcomes}
                />
              </div>

              <ActionButtons
                mainAction={submit}
                mainActionText="Submit"
                mainActionDisabled={false}
                currentStatus={status}
                ref={actionButtons} />
              <span
                tabIndex="0"
                className="Contact-Us-Contents__focus-control"
                onFocus={focusFirstItem}></span>
            </form>
            <p className="Contact-Us-Contents__submission__instructions">* Required</p>
          </div>
        </main>
      </div>
      <footer>

        <StatusFooter />
      </footer>

    </div>

  );
}





